"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateExtendedTableShock = exports.finalSum = exports.sumTotalRow = exports.getCoinGroupTable = exports.getReducedExtendedMargin = void 0;
const types_1 = require("../types");
const pmParams_1 = require("./pmParams");
const marketShift_1 = require("./marketShift");
const utils_1 = require("./utils");
const getReducedExtendedMargin = (currencyPnlMap, marginMultipliers) => {
    return Object.keys(currencyPnlMap).reduce((memo, currency) => {
        return Object.assign(Object.assign({}, memo), { [currency]: currencyPnlMap[currency].map((x, i) => x[1] * marginMultipliers[i]) });
    }, {});
};
exports.getReducedExtendedMargin = getReducedExtendedMargin;
const getPnlMapForCurrencies = (currencyPnl, currencies) => {
    let res = {};
    for (const currency of currencies) {
        if (currencyPnl[currency]) {
            res[currency] = currencyPnl[currency];
        }
    }
    return res;
};
const getCoinGroupTable = (currencyPnl, productGroup, pmParams) => {
    const productGroupCurrencies = Object.keys(pmParams.currencyParams).filter((currency) => pmParams.currencyParams[currency].group === productGroup);
    const productGroupPnlMap = getPnlMapForCurrencies(currencyPnl, productGroupCurrencies);
    const factors = productGroup === pmParams_1.ProductGroup.LargeCap
        ? pmParams.general.largeCapExtendedTableFactors
        : pmParams.general.midCapExtendedTableFactors;
    const reducedExtendedMargin = (0, exports.getReducedExtendedMargin)(productGroupPnlMap, factors);
    return reducedExtendedMargin;
};
exports.getCoinGroupTable = getCoinGroupTable;
const sumTotalRow = (currencyPnl, pmParams) => {
    const length = currencyPnl[Object.keys(currencyPnl)[0]].length;
    return (0, utils_1.getEmptyMovesRow)(length).map((_, i) => {
        return Object.keys(currencyPnl).reduce((memo, currentCurrency) => {
            const marginMultiplier = pmParams.currencyParams[currentCurrency].group === pmParams_1.ProductGroup.LargeCap
                ? pmParams.general.largeCap
                : pmParams.general.midCap;
            const currencyImpact = currencyPnl[currentCurrency][i] < 0
                ? currencyPnl[currentCurrency][i]
                : currencyPnl[currentCurrency][i] * marginMultiplier;
            return memo + currencyImpact;
        }, 0);
    });
};
exports.sumTotalRow = sumTotalRow;
const finalSum = () => { };
exports.finalSum = finalSum;
const calculateExtendedTableShock = (extendedMarketShiftTable, normalMarketShiftTableInfo, pmParams, positionsUuidMap) => {
    const { currencyPnl } = (0, marketShift_1.getCurrencyPnlMap)(extendedMarketShiftTable, positionsUuidMap, pmParams, []);
    const largeCapFactoredTable = (0, exports.getCoinGroupTable)(currencyPnl, pmParams_1.ProductGroup.LargeCap, pmParams);
    const medCapFactoredTable = (0, exports.getCoinGroupTable)(currencyPnl, pmParams_1.ProductGroup.MidCap, pmParams);
    const flatExtendedTable = (0, utils_1.reduceExtendedTableSize)(currencyPnl);
    const totalMultiplied = (0, exports.sumTotalRow)(Object.assign(Object.assign({}, largeCapFactoredTable), medCapFactoredTable), pmParams);
    const totalNotMultiplied = (0, exports.sumTotalRow)(flatExtendedTable, pmParams);
    const { min: minTotalMultiplied, index: minIndex } = (0, utils_1.minWithIndex)(totalMultiplied);
    const minTotalNotMultiplied = Math.min(...totalNotMultiplied);
    const min = minTotalMultiplied <
        normalMarketShiftTableInfo.totalSumMin *
            pmParams.general.extendedTableShock.minFactor
        ? minTotalNotMultiplied
        : 0;
    const absoluteMin = Math.abs(min);
    const shock = absoluteMin < pmParams.general.extendedTableShockCutOff
        ? 0
        : (absoluteMin - pmParams.general.extendedTableShockCutOff) *
            pmParams.general.extendedTableShock.finalShockDifferenceFactor;
    const { marketShiftOutlook: normalTableMarketShiftOutlook } = (0, utils_1.getMarketShiftOutlook)(pmParams.currencyParams.BTC.moves, normalMarketShiftTableInfo.marginRequirements);
    const extendedTableMarketShiftOutlook = pmParams.currencyParams.BTC.extendedMoves[minIndex] < 0
        ? types_1.MarketShiftOutlook.DOWN
        : types_1.MarketShiftOutlook.UP;
    return {
        totalMultiplied,
        totalNotMultiplied,
        shock,
        normalTableMarketShiftOutlook,
        extendedTableMarketShiftOutlook,
        minTotalMultiplied,
        largeCapFactoredTable,
        medCapFactoredTable,
        flatExtendedTable,
        currencyPnl,
    };
};
exports.calculateExtendedTableShock = calculateExtendedTableShock;
